import $ from 'jquery';
import 'whatwg-fetch';

import { windowOnLoad } from './common';

/* eslint-disable */
const req = require.context('../css/contact', true, /^(.*\.(css$))[^.]*$/igm);
req.keys().forEach((key)=>{req(key);});
/* eslint-enable */

const validateEmail = (email) => {
	/* eslint-disable max-len */
	/* eslint-disable no-useless-escape */
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	/* eslint-enable max-len */
	/* eslint-enable no-useless-escape */
	return re.test(email);
};

$(document).ready(() => {
	if (navigator.userAgent.match(/android/i)) return;
	if (navigator.userAgent.match(/(iphone|ipad|ipod);?/i)) {
		document.querySelector('.half-width.-form').classList.add('-scroll');
	}
	/**
	 * send a mail to hey@25sprout.com
	 */
	document.querySelector('.half-width.-form > .button').addEventListener('click', () => {
		if (!document.querySelector('.half-width.-form').classList.contains('-success')) {
			let textValidation = false;

			if (document.querySelector('.half-width.-form > .user.-text').value) {
				textValidation = true;
			}

			const mailValidation = validateEmail(
				document.querySelector('.half-width.-form > .user.-mail').value,
			);

			if (textValidation && mailValidation) {
				document.querySelector('.half-width.-form').className = 'half-width -form';
				$('.half-width > .mask').fadeIn(600);

				fetch('https://www.25sprout.com/aws_ses/index_super.php', {
					method: 'POST',
					body: [
						'mailer=aws',
						'Source=hey@25sprout.com',
						'ToAddresses=hey@25sprout.com',
						'Subject=25sprout Contact Form',
						`Body=Name: <b>${$('.half-width.-form > .user.-username').val()}</b>,<br/>
							E-Mail: ${$('.half-width.-form > .user.-mail').val()},<br/>
							Phone: ${$('.half-width.-form > .user.-phone').val()},<br/>
							Type: ${$('.half-width.-form > .typeselect').val()},<br/>
							Content: ${$('.half-width.-form > .user.-text').val()}`,
						'ReplyToAddresses=hey@25sprout.com',
						'ReturnPath=hey@25sprout.com',
						'Success=成功寄出，謝謝您的來信',
						'Failed=信件尚未寄出，請稍後再試',
					].join('&'),
				})
					.then((response) => response.json())
					.then((data) => {
						if (data.state) {
							$('.half-width > .mask').fadeOut(400);

							document.querySelector('.half-width.-form > .user.-username').value = '';
							document.querySelector('.half-width.-form > .user.-mail').value = '';
							document.querySelector('.half-width.-form > .user.-phone').value = '';
							document.querySelector('.half-width.-form > .user.-text').value = '';

							document.querySelector('.half-width.-form').className += ' -success';
							document.querySelector('.success-msg').className += ' bounceInRight';

							setTimeout(() => {
								document.querySelector('.success-msg').style.display = 'none';
							}, 2000);
						}
					});
			} else {
				let newClassName = 'half-width -form';

				if (mailValidation === false) {
					newClassName += ' -errormail';
				}

				if (textValidation === false) {
					newClassName += ' -errortext';
				}

				document.querySelector('.half-width.-form').className = newClassName;

				if (mailValidation === false) {
					document.querySelector('.half-width > .-mail').focus();
				} else {
					document.querySelector('.half-width > .-text').focus();
				}
			}
		}
	});
});

window.onload = () => {
	windowOnLoad();
};



// WEBPACK FOOTER //
// ./src/js/contact.js